import React from 'react'
import PropTypes from 'prop-types'

import { Column, Columns } from '@resurs/midas-react'

import pageableTable from '../../../higher-order/pageable-table'
import searchableTable from '../../../higher-order/searchable-table'

import NewsArticle from './NewsArticle'

const NewsList = ({ articles }) => (
  <section>
    <Columns>
      <Column col2 colMd2 colSm12 />
      <Column col8 colMd8 colSm12>
        {articles.map(article => (
          <NewsArticle key={article.id} article={article} />
        ))}
      </Column>
      <Column col2 colMd2 colSm12 />
    </Columns>
  </section>
)

NewsList.propTypes = {
  articles: PropTypes.array.isRequired,
}

export default searchableTable(pageableTable(NewsList))
